import { List, TextField, Datagrid, DeleteButton, EditButton, useRecordContext, ReferenceField } from "react-admin";
import { CustomImage, EmptyList } from "common/components";

import filters from "./Filter";
import { getImgUrl } from "common/imageUtils";
import { settings } from "app";

const ListGallery = () => {
  return (
    <List
      title="Галерия"
      hasCreate
      exporter={false}
      filters={filters}
      queryOptions={{ meta: { mixed_provider: true } }}
    >
      <Datagrid
        empty={<EmptyList />}
        bulkActionButtons={false}
      >
        <TextField
          source="id"
          sortable={false}
        />
        <TextField
          source="name"
          sortable={false}
          label="Име"
        />
        <ReferenceField
          reference={"applications-cms"}
          source="applicationId"
          label="Application"
        >
          <TextField source="name" />
        </ReferenceField>
        <MediaImageField />
        {/* <ShowButton /> */}
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
export default ListGallery;

const MediaImageField = () => {
  const record = useRecordContext();
  return (
    <CustomImage
      altText="image"
      url={getImgUrl(`${settings.cmsApi}/media`, record.name, "default", true)}
      height="200"
      maxWidth="300px"
    />
  );
};